import { atom } from "jotai";

export const citysList=atom({})